// @file pinia store for landside quote modal state
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLandsideQuoteModalStore = defineStore('landsideQuoteModal', () => {
  const isQuoteModalOpen = ref(false)

  const openQuoteModal = (): void => {
    isQuoteModalOpen.value = true
  }

  const closeQuoteModal = (): void => {
    isQuoteModalOpen.value = false
  }

  return {
    isQuoteModalOpen,
    openQuoteModal,
    closeQuoteModal,
  }
})
